import { Typography, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { events, track } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import useNotesBlockStyles from './styles';
export const NotesBlock = observer(_ref => {
  let smallHeader = _ref.smallHeader;
  const classes = useNotesBlockStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleChange = e => {
    if (e.target.value.length <= 255) store.enrollResident.changeInUnitValue('notes', e.target.value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: smallHeader ? 'h5' : 'h4'
  }, t('enrollment_modal.notes_reg_resident')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: t('general.add_notes_here'),
    id: "notes",
    maxRows: 10,
    multiline: true,
    onBlur: () => track(events.filled('Resident Notes')),
    onChange: handleChange,
    rows: 4,
    value: store.enrollResident.enrollResidentInUnit.notes,
    variant: "outlined"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", store.enrollResident.enrollResidentInUnit.notes.length, "/255)")));
});